import Endpoint from "@/utils/endPoint";

const themeTypeEndpoint = new Endpoint("/tags/types");
const themeListEndpoint = new Endpoint("/tags/teachers/");
const themeEndpoint = new Endpoint("/tags/teachers/{id}");
const archiveThemeEndpoint = new Endpoint("/tags/teachers/{id}/archive");
const unarchiveThemeEndpoint = new Endpoint("/tags/teachers/{id}/unarchive");

class ThemeService {
    async getThemeTypeService(params) {
        const result = await themeTypeEndpoint.get(params);
        return result;
    }

    async getThemeListService(params) {
        const result = await themeListEndpoint.get(params);
        return result;
    }

    async createThemeService(params) {
        const result = await themeListEndpoint.post(params);
        return result;
    }

    async delThemeService(params) {
        const result = await themeEndpoint.del(null, params);
        return result;
    }

    async updateThemeService(params) {
        const { id, ...param } = params;
        const result = await themeEndpoint.put(param, { id });
        return result;
    }

    async getThemeService(params) {
        const result = await themeEndpoint.get(params);
        return result;
    }

    async archiveThemeService(params) {
        const { id, ...param } = params;
        const result = await archiveThemeEndpoint.put(param, { id });
        return result;
    }

    async unarchiveThemeService(params) {
        const { id, ...param } = params;
        const result = await unarchiveThemeEndpoint.put(param, { id });
        return result;
    }
}

export default new ThemeService();
